<!--
-->
<template>
  <context-view :visible="contextViewVisible" />
  <!-- 'router-view' is a "global" component that is injected into the Vue component registry by vue-router. -->
  <router-view />
</template>

<script>
import ContextView from './ContextView';
import { dictionaryServiceFactory } from './lib/dictionary-service-factory';

export default {
  name: 'AppRoot',
  data() {
    return {
      contextViewVisible: false
    };
  },
  methods: {
    toggleContextView() {
      this.contextViewVisible = !this.contextViewVisible;
    }
  },
  provide() {
    // Use Vue's provide/inject capabilities to "provide" functions to
    // any descendant component that want to use/"inject" the functions.
    return {
      toggleContextView: this.toggleContextView
    };
  },
  components: {
    ContextView
  }
};
</script>
